import { styled } from '@portfolio/styles'
import { ReactNode } from 'react'
import { Link } from '../Link/Link'

const ChipItem = styled(Link, {
  projectFont: 'ui04',
  borderRadius: '$rMax',
  display: 'inline-flex',
  padding: '$6 $12',
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  lineHeight: '1.4',
  width: 'fit-content',
  cursor: 'pointer',
  transition: '0.2s color, 0.2s background',

  '&:focus-visible': {
    outline: '$focusBlue solid 3px;',
  },

  variants: {
    type: {
      dark: {
        color: '$black',
        border: '1px solid $black',
        '@lg': {
          '&:hover': {
            color: '$white',
            background: '$black',
          },
        },
      },
      darkDisabled: {
        color: '$black',
        border: '1px solid $black',
        cursor: 'default',
      },
      light: {
        color: '$white',
        border: '1px solid $white',
        '@lg': {
          '&:hover': {
            color: '$black',
            background: '$white',
          },
        },
      },
      lightDisabled: {
        color: '$white',
        border: '1px solid $white',
        cursor: 'default',
      },
      gray: {
        background: '$white_005',
        color: '$white',
        padding: '$6 $16',
        backdropFilter: 'blur(30px)',
        WebkitBackdropFilter: 'blur(30px)',
        '@lg': {
          '&:hover': {
            background: '$white_01',
          },
        },
      },
    },
  },

  defaultVariants: {
    type: 'dark',
  },
})

type ChipProps = {
  title: ReactNode
  type?: 'dark' | 'darkDisabled' | 'light' | 'lightDisabled' | 'gray'
  disabled?: boolean
  href: string
}

export const Chip = ({
  title,
  type = 'dark',
  disabled = false,
  href,
}: ChipProps) => (
  <ChipItem type={type} href={href} aria-disabled={disabled}>
    {title}
  </ChipItem>
)
